<template>
  <div id="app">
    <header>
      <h1>Music</h1>
    </header>
    <body>
    <main>
      <section class="player">
          <h2 class ="music-titre">{{current.titre}} <span>{{current.artist}}</span></h2>
         <div class ="controle">
           <button class="prev" @click="prev">Prev</button>
           <button class="play" v-if="!isPlaying" @click="play">Play </button>
           <button class="pause" v-else @click="pause">Pause</button>
           <button class="next" @click ="next">Next</button>
         </div>
      </section>
      <section class ="playlist">
        <h3>Playlist</h3>
          <button v-for="song in song" :key="song.src" @click="play(song)" :class="(song.src == current.src) ? 'song playing' : 'song'">
            {{song.titre}} - {{song.artist}}

          </button>
      </section>
    </main>
    </body>
  </div>
</template>

<script>


export default {
  name: 'App',
  data(){
    return {
      current: {},
      index: 0,
      isPlaying : false,
      song:[
      {
        titre:"luv-sic-part3",
        artist:"nujabes",
        src: require("../src/assets/nujabes-luv-sic-pt-3-ftshing02.mp3")
      },
      {
         titre:"windspeaks",
        artist:"nujabes",
        src: require('../src/assets/nujabes-windspeaks.mp3')
      },
      {
        titre:"mystline",
        artist:"nujabes",
         src: require('../src/assets/nujabes-mystline-full-version.mp4')
      },
      {
        titre:"tsurugi-no-mai",
        artist:"nujabes",
         src: require('../src/assets/nujabes-tsurugi-no-mai.mp3')
      },
      {
        titre:"love-sick-part2",
        artist:"nujabes",
         src: require('../src/assets/nujabes-love-sick-part-2.mp3')
      },
      {
        titre:"reflection eternal",
        artist:"nujabes",
         src: require('../src/assets/nujabes-reflection-eternal-hd.mp3')
      },
       {
        titre:"folklore",
        artist:"nujabes",
         src: require('../src/assets/nujabes-imaginary-folklore.mp3')
      },
      ],
      player: new Audio()
    }
  },
  methods:{
    play(song){
      if(typeof song.src != "undefined"){
        this.current = song;
        this.player.src = this.current.src;
      }
      this.player.play();
      this.player.addEventListener('ended',function(){
        this.index++;
        if(this.index > this.song.length -1) {
        this.index = 0;
      }
      this.current = this.song[this.index];
      this.play(this.current);
      }.bind(this));
      this.isPlaying = true;
    },
    pause(){
      this.player.pause();
      this.isPlaying = false;
    },
    next(){
      this.index++;
      if(this.index > this.song.length -1) {
        this.index = 0;
      }
      this.current = this.song[this.index];
      this.play(this.current);
    },
    prev(){
         this.index--;
      if(this.index < 0) {
        this.index = this.song.length - 1 ; 
      }
      this.current = this.song[this.index];
      this.play(this.current);
    },
  },
  created(){
    this.current = this.song[this.index];
    this.player.src = this.current.src;
    
  }
}
</script>

<style>
*{
  margin: 0;
  padding: 0; 
  box-sizing:border-box;
}
body{
  font-family: fantasy;
  background-image:url("../src/assets/daniel-buckle-GE5OTnESaXU-unsplash.jpg");
   background-repeat: no-repeat;
    height:108rem;
    background-size:cover;
    background-position:center;
    background-attachment: fixed
}
header{
  display:flex;
  justify-content:center;
  align-items: center;
  padding :15px;
  background-color:black;
  color:#fff
}
main{
  width : 100%;
  max-width : 768px;
  margin: 0 auto ;
  padding:25px;
}
.music-titre{
color:grey;
font-size:32px;
font-weight:700;
text-transform: uppercase;
text-align:center;
}
.music-titre span{
  font-weight:400;
  font-style:italic
}
.controle{
  display:flex;
  justify-content: center;
  padding: 30px 15px;
  align-items: center; 
}
button{
  appearance: none ; 
  background:none;
  border : none ; 
  outline : none; 
  cursor: pointer; 
}
button:hover{
  opacity:0.8;
}
.play{
font-size:20px;
font-weight:700;
padding:15px 25px;
margin:0px 15px;
border-radius:8px;
color:white;
background-color:midnightblue;
}
.next, .prev{
  font-size:16px;
font-weight:700;
padding:15px 20px;
margin:0px 15px;
border-radius:6px;
color:white;
background-color:FireBrick;
}
.playlist h3{
color:black;
font-size:28px;
font-weight:400;
margin-bottom:30px;
text-align:center;
}
.playlist .song{
  display:block;
  width:100%;
  padding:15px;
  font-size:20px;
  font-weight:700;
  cursor:pointer;
}
.playlist .song:hover{
color:wheat,
}
.playlist .song.playing{
  color:white;
  background-image:linear-gradient(to right,red,black )
}

</style>
